"use client";

import React from "react";
import { MobileMenu as Menu, useHeader } from "@/components/project/Header";
import Drawer from "@/components/ui/Drawer";
import type { MobileMenuProps } from "./types";

function MobileMenu({ children, ...props }: MobileMenuProps) {
  const { setIsVisible } = useHeader();

  const handleOnAnimationEnd = React.useCallback(
    (modalOpen: boolean) => {
      if (!modalOpen) {
        setIsVisible(true);
      }
    },
    [setIsVisible],
  );

  return (
    <Drawer
      modal={false}
      direction="right"
      onAnimationEnd={handleOnAnimationEnd}
      {...props}
    >
      <Menu />
      {children}
    </Drawer>
  );
}

export default MobileMenu;
